export default __webpack_public_path__ + "static/media/08-analogue-situations.fbd3c959.png";